import React from "react";
import { useI18n } from "@/context/I18nContext";
import { ShieldCheck } from "lucide-react";

/** Enforces the "if fewer than N active users, hide" privacy rule.
 *  Never exposes individual data. Backend also enforces this; this component
 *  is a client-side belt-and-braces + copy. */
export default function PrivacySafe({ minUsers = 5, count, children, testId = "privacy-safe" }) {
  const { lang } = useI18n();
  const n = Number(count ?? NaN);
  const insufficient = Number.isFinite(n) && n < minUsers;

  if (insufficient) {
    return (
      <div
        className="rounded-3xl border border-dashed border-sage-500/40 bg-sage-50 p-6 flex items-start gap-3"
        data-testid={testId}
      >
        <div className="h-9 w-9 rounded-xl bg-sage-100 flex items-center justify-center shrink-0">
          <ShieldCheck className="h-4 w-4 text-sage-700" strokeWidth={1.75} />
        </div>
        <div>
          <div className="font-heading text-ink-900">
            {lang === "nl" ? "Niet genoeg gegevens om privacy veilig te tonen." : "Not enough data to display privacy-safely."}
          </div>
          <div className="text-sm text-ink-500 mt-1">
            {lang === "nl"
              ? `Analyses worden alleen getoond bij minimaal ${minUsers} actieve gebruikers. Zo blijven individuele gegevens onherleidbaar.`
              : `Analytics appear once at least ${minUsers} active users are present, keeping individual data anonymous.`}
          </div>
        </div>
      </div>
    );
  }
  return <>{children}</>;
}

export function PrivacyBadge({ testId = "privacy-badge" }) {
  const { lang } = useI18n();
  return (
    <div className="inline-flex items-center gap-1.5 rounded-full bg-sage-50 border border-sage-200 text-sage-700 text-xs px-2.5 py-1" data-testid={testId}>
      <ShieldCheck className="h-3 w-3" strokeWidth={2} />
      {lang === "nl" ? "Geanonimiseerd, geaggregeerd" : "Anonymised, aggregated"}
    </div>
  );
}
